import { APP_STORE_LINK } from "../../constants"

interface Props {
  className?: string
}

const NavigationBadge = ({ className = "" }: Props) => (
  <a
    className={`${className} p-3 pr-1 max-w-[256px] flex flex-col gap-1 bg-[#342B7F] border border-[#4E49AB] rounded-lg  hover:no-underline text-white`}
    href={APP_STORE_LINK}
    target="_blank"
    rel="noreferrer"
  >
    <strong className="text-base font-bold font-serif">
      {" "}
      Download Mobile App
    </strong>
    <div className="whitespace-break-spaces text-sm">
      Your Mortgage Lead Command Center—Now in Your Pocket
    </div>

    <div className="text-primary-400 underline decoration-dashed underline-offset-4 text-sm text-medium">
      Download Now
    </div>
  </a>
)

export default NavigationBadge
